<template>
  <TableLayout :permissions="['business:workorder:query']">
    <!-- 搜索表单 -->
    <div slot="search-form">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" inline>
        <el-form-item label="观察主题" prop="typeId">
          <el-select v-model="searchForm.typeId" @change="changeType" style="width: 120px">
          <el-option  clearable filterable
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
          </el-select> -
        </el-form-item>
        <el-form-item label="" prop="categoryId">
          <el-select v-model="searchForm.categoryId" @change="search" style="width: 120px">
          <el-option  clearable filterable
              v-for="item in categorys1"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上报人员" prop="memberName">
          <el-input v-model="searchForm.memberName" clearable placeholder="人员姓名或手机号" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="工单号" prop="code">
          <el-input v-model="searchForm.code" clearable placeholder="请输入工单号" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
    </div>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:workorder:exportExcel']">
        <li> <el-button type="primary" :loading="isWorking.export" @click="exportExcel">导出</el-button></li>
      </ul>
      <el-table
        :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="code"  label="工单号" min-width="150px" fixed>
          <template slot-scope="{row}">
            <span style="color: #2E68EC;cursor: pointer" @click="$refs.operaWorkorderWindow.open('DCA事件工单详情', row)" >{{ row.code || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="typeName" label="观察主题" min-width="100px">
          <template slot-scope="{row}"> {{row.typeName}}/{{row.categoryName}}
          </template>
        </el-table-column>
<!--
        <el-table-column prop="categoryName" label="二级主题" min-width="100px"></el-table-column>
-->
        <el-table-column prop="problemTitle" label="不符合项" min-width="250px"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px">
          <template slot-scope="{row}">
            <span :class="'statusInfo'+row.status" v-if="row.status ==0">待处理</span>
            <span :class="'statusInfo'+row.status" v-else-if="row.status ==3 ||row.status ==4||row.status ==5">已处理</span>
            <span :class="'statusInfo'+row.status" v-else>处理中</span>
          </template>
        </el-table-column>
        <el-table-column prop="locationName" label="位置" min-width="150px"></el-table-column>
        <el-table-column prop="submitDate" label="上报时间" min-width="150px"></el-table-column>
        <el-table-column prop="happenTime" label="发现时间" min-width="150px"></el-table-column>
        <el-table-column prop="memberName" label="上报人员" min-width="150px">
          <template slot-scope="{row}">
            <span v-if="row.memberPhone" >{{row.memberName}}/{{row.memberPhone }}</span>
            <span v-else >{{row.memberName}} </span>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="所属部门" min-width="150px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="150px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:workorder:update', 'business:workorder:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaWorkorderWindow.open('DCA事件工单详情', row)" icon="el-icon-zoom-out" >查看详情</el-button>
          <!--<el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:workorder:delete']">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaWorkorderDetailDcaInfoWindow ref="operaWorkorderWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaWorkorderDetailDcaInfoWindow from '@/components/business/OperaWorkorderDetailDcaInfoWindow'
import { allList } from '@/api/business/category'
export default {
  name: 'Workorder',
  extends: BaseTable,
  components: {TableLayout, Pagination, OperaWorkorderDetailDcaInfoWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        type: '2',
        memberName: '',
        memberCompanyId: '',
        localtionId: '',
        categoryId: '',
        typeId: '',
        code: '',
        categoryList: []
      },
      categoryprops: {
        label: 'name',
        value: 'id',
        checkStrictly: true,
        lazyLoad: this.lazyLoad
      },
      categorys: [],
      categorys1: []
    }
  },
  created () {
    this.config({
      module: '工单信息表',
      api: '/business/workorder',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.loadCategorys()
    this.search()
  },
  methods: {
    changeType(){
      this.search()
      this.categorys1 = []
      this.searchForm.categoryId = null
      this.loadCategorys1()
    },
    handleChangeCategory (value) {
      if (this.searchForm.categoryList && this.searchForm.categoryList.length >= 1) {
        this.searchForm.typeId = this.searchForm.categoryList[this.searchForm.categoryList.length - 1]
      }
    },
    loadCategorys () {
      allList({ type: 4, isRoot:1})
        .then(res => {
          if (res && res.length > 0) {
            this.categorys = res
          }
        })
    },
    loadCategorys1 ( ) {
      if (!this.searchForm.typeId) {
        return
      }
      allList({ type: 4, parentId: this.searchForm.typeId })
        .then(res => {
          if (res && res.length > 0) {
            this.categorys1 = res
          }
        })
    },
  }
}
</script>
